import { createContext } from 'react';
import { Subject } from 'rxjs';
import { DefaultSharedStore } from './default-shared-store';
import { SharedCollectionResolver } from './shared-value-resolving';
export var SharedValueContext = createContext(new DefaultSharedStore());
export var APP_EVENTS = createSharedCollectionKey('app_events', function () { return new Subject(); });
export var AppInitialized = 'app_initialized';
export var createSharedValueKey = function (id, defaultValue) { return ({ id: id, defaultValue: defaultValue }); };
export function createSharedCollectionKey(name, values) {
    if (isResolver(values))
        return createResolvedCollectionKey(name, values);
    return {
        id: name,
        defaultValue: new DefaultSharedStore(),
        defaultKeyValue: values,
        collection: true
    };
}
function createResolvedCollectionKey(name, resolver) {
    var collection = new DefaultSharedStore();
    var collectionResolver = new SharedCollectionResolver(name, collection, resolver);
    return {
        id: name,
        defaultValue: collection,
        collection: true,
        resolver: collectionResolver
    };
}
function isResolver(values) {
    return !!values && typeof values === 'object';
}
// Just to simplify type capture so devs don't have to explicitly define their service contracts
export function sharedService(factory) {
    return factory;
}
//# sourceMappingURL=shared-values.model.js.map